import { EntitesProdutoAgregado } from "app/components/agregados/Agregados";
import { Atividade } from "app/components/atendimento/CadastrarAtendimento/CadastrarAtendimento";
import { ListaConcorrentes, ListaMotivos } from "app/components/editar-item/registrar-perda-cotacao/RegistarPerdaCotacao";
import { DadosProdutoControleLote } from "app/components/itens-orcamento/produto-controle-lote/ProdutosControleLote";
import { DadosProdutosLote, Lotes } from "app/components/itens-orcamento/produto-controle-lote/produto-lote/ProdutoLote";
import { EntitesSimilares } from "app/components/similares/Similares";
import { ProdutosSugeridos } from "app/components/sugerir-produto-agregado/SugerirProdutoAgregado";
import { OrcamentoUnificacao, UnificacaoDeOrcamentosFiltroPesquisa } from "app/components/unificacao-de-orcamentos/UnificacaoDeOrcamentos";
import { DefinirAutorizadoSelecionado, FiltroDefinirAutorizado, FiltroListarAutorizados, ListaAutorizado } from "app/types/Autorizado";
import { CodigoTurnoEntrega } from "app/types/CodigoTurnoEntrega";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import { DescontoAplicados, DescontoOrcamento } from "app/types/Desconto";
import { Endereco } from "app/types/Endereco";
import { DadosFaturamento } from "app/types/FaturamentoOutrasSaidas";
import { ICliente } from 'app/types/ICliente';
import { IIndicador } from 'app/types/IIndicador';
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { ITipoFaturamento } from "app/types/ITipoFaturamento";
import { DadosParcela } from "app/types/IncluirEditarParcela";
import { LiberarPendenciaResposta } from "app/types/LiberarPendenciaResposta";
import { Markup, produtoMarkupAlterado } from "app/types/Markup";
import { AtualizarDadosResumoOrcamento, DadosResumoOrcamento } from "app/types/Resumo";
import { DadosTrocarFilialOrcamento } from "app/types/TrocarFilialOrcamento";
import { Vendedor } from "app/types/Vendedor";
import { DomainDataPendenciaCliente } from "app/types/cliente/DomainDataPendenciaCliente";
import { CadastroIndicador } from "app/types/comissoes/DadosBasicosIndicadores";
import { DetalhesComissoes, FiltroListarIndicador, Indicadores, ProgramaDeRelacionamento } from "app/types/comissoes/Indicadores";
import { DadosIncluirProfissionais, FiltroListarProfissionais, ProfissionalComissoes } from "app/types/comissoes/Profissionais";
import { DadosIncluirVendedores, FiltroListarVendedores } from "app/types/comissoes/Vendedores";
import { SalvarEnderecoOrcamento } from 'app/types/enderecoOrcamento/SalvarEnderecoOrcamento';
import { RespostaModalEnviarEmail } from "app/types/modalImprimir/RespostaModalImprimir";
import { ItensTotaisOrcamento } from "app/types/orcamento/ItensTotaisOrcamento";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";
import { DadosCancelarOrcamento, ItensACancelar, NecessitaAutorizacaoExclusaoFinanceiro, PedidoCancelado } from "app/types/pesquisa-orcamento/CancelarOrcamento";
import { DadosPesquisaOrcamento, DadosTotalDaPesquisaOrcamento, FiltroPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { DadoHistoricoOrcamento } from "app/types/pesquisa-orcamento/consultas/Historico";
import { IProduto } from "app/types/produto/IProduto";
import { DadosTabelaProdutosForaEstoque } from "app/types/produto/ProdutoForaEstoque";
import { SimulacaoPrecoItemContract } from "app/types/simulacao-preco/SimulacaoPrecoItemContract";
import { AxiosRequestConfig } from "axios";
import globalMU from "globalMU";
import { Entrega } from "../../components/entrega/aba-entrega/aba-entrega";
import { TipoEntrega } from "../../components/entrega/aba-tipo-entrega/AbaTipoEntrega";
import { OpcaoEntrega } from "../../components/entrega/aba-tipo-entrega/editar-tipo-entrega/EditarTipoEntrega";
import { Frete } from "../../components/entrega/frete/AbaFrete";
import { Transportadora } from "../../types/AbaTransportadora";
import { DadosDestinoTransferencia } from "../../types/DadosDestinoTransferencia";
import { DadosEntrega } from "../../types/DadosEntrega";
import { DadosTransportadora } from "../../types/DadosTransportadora";
import { ICentroCusto } from "../../types/ICentroCusto";
import { IFilial } from "../../types/IFilial";
import { DomainDataType } from "../types/DomainDataType";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";
import { DespesaOrcamento } from "app/components/DespesasOrcamento/DespesasOrcamento";
import { InputAdicionarCodigoServicoAgregado, ServicoAgregado } from "app/types/ServicoAgregado";
import { TipoInconsistencia } from "app/types/FinalizarOrcamento";
import { int } from "@zxing/library/esm/customTypings";
import { DadosOrcamentoAlterarValidade } from "app/components/AlterarValidadePedido/AlterarValidadePedidoContainer";
import { remover } from "app/redux/parametrosSlice";
import { CanalDeVenda } from "app/types/orcamento/MotivoDesconto";



export class OrcamentoApi extends BaseApi {
    async adicionarItens(identificadorOrcamento: string, produtos: IProduto[] | EntitesProdutoAgregado[] | EntitesSimilares[] | ProdutosSugeridos[]): Promise<DomainDataType<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/AdicionarItens`, {
            identificadorOrcamento: identificadorOrcamento,
            produtos: produtos
        })

        return resposta?.data
    }

    // Marca na Fenix quais pré-vendas foram convertidas em itens deste orçamento (ver
    // OrcamentoController.DefinirPreVendas/OrcamentoService.DefinirPreVendas) — usado só depois de
    // adicionarItens confirmar sucesso (ver onAdicionarItensGrid em PaginaPesquisaProdutoContainer.tsx).
    async definirPreVendas(identificadorOrcamento: string, idsPreVenda: number[]): Promise<boolean> {
        const resposta = await this.api.post(`/Orcamento/DefinirPreVendas`, {
            identificadorOrcamento,
            idsPreVenda
        })

        return resposta?.data
    }

    // 482572 — cenário "orçamento NOVO ainda não gravado": adiciona os itens do snapshot e, na
    // mesma ida ao servidor, reaplica os campos pendentes (tipo de entrega, filial, datas, etc.)
    // via orcamentobase.prg::RestaurarDadosPendentesOrcamentoNaoGravado (ver
    // OrcamentoService.RestaurarOrcamentoNaoGravado). `dadosOrcamentoEmAndamento` é o mesmo formato
    // JSON (`{ Orcamento: <snapshot> }`) usado por _Menu.cshtml para o cenário GRAVADO.
    async restaurarOrcamentoNaoGravado(identificadorOrcamento: string, produtos: IProduto[], dadosOrcamentoEmAndamento: string): Promise<DomainDataType<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/RestaurarOrcamentoNaoGravado`, {
            identificadorOrcamento,
            produtos,
            dadosOrcamentoEmAndamento
        })

        return resposta?.data
    }

    async validarReceberEntrega(identificadorOrcamento: string): Promise<boolean> {
        const resposta = await this.api.post(`/Orcamento/ValidarReceberEntrega`, {
            identificadorOrcamento: identificadorOrcamento
        })

        return resposta?.data === true
    }

    async validarContaPortadorTipoDocumento(identificadorOrcamento: string, oidTipoDocumento : number): Promise<number> {
        const resposta = await this.api.post(`/Orcamento/ObterContaPortadorTipoDocumento`, {
            identificadorOrcamento,
            oidTipoDocumento
        })

        return resposta?.data
    }

    async atualizarEntrega(atualizarEntrega: Entrega): Promise<Partial<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/AtualizarEntrega`, {
            atualizarEntrega
        })

        return resposta?.data
    }

    async ValidarProdutoComPrecoDiferente(numeroPedidoValidar: number, listaPedidosSelecionados: number[]): Promise<boolean> // 427169
    {
        const resposta = await this.api.post(`/UnificacaoDeOrcamentos/ValidarProdutoComPrecoDiferente`, {
            numeroPedido: numeroPedidoValidar,
            listaJaSelecionados: listaPedidosSelecionados
        })

        return resposta?.data;
    }

    async obterListaOrcamentosUnificaveis(filtros: UnificacaoDeOrcamentosFiltroPesquisa): Promise<PagedMessageResponse<OrcamentoUnificacao>> // 427169
    {
        const resposta = await this.api.post(`/UnificacaoDeOrcamentos/BuscarListaOrcamentosUnificacao`, {
            OidCliente: filtros.ClienteSelecionado?.Codigo,
            DataInicialPedido: filtros.DataInicial,
            DataFinalPedido: filtros.DataFinal,
            NumeroPagina: filtros.NumeroPagina,
            TamanhoPagina: filtros.TamanhoPagina
        })

        return resposta?.data;
    }

    async unificarOrcamentos(listaPedidosUnificar: number[]): Promise<number> // 427169
    {
        const resposta = await this.api.post(`/UnificacaoDeOrcamentos/Unificar`, {
            Pedidos: listaPedidosUnificar,
        })
        return resposta?.data.Resultado;
    }

    async definirObra(identificadorOrcamento: string, idObra: number): Promise<Partial<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/DefinirObra`, {
            identificadorOrcamento,
            idObra
        })

        return resposta?.data
    }

    async ObterIdObra(identificadorOrcamento: string): Promise<number> {
        return (await this.api.get(`/Orcamento/ObterIdObra`, {
            params: {
                identificadorOrcamento
            }
        })).data
    }

    async DefinirPreservaDesconto(identificadorOrcamento: string, identificadorItem: number, preservaDesconto: boolean): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirPreservaDescontoItemOrcamento`, {
            identificadorOrcamento,
            identificadorItem,
            preservaDesconto
        })).data
    }

    async VerificarClienteSemAreaVenda(identificadorOrcamento: string, codigoCliente: number): Promise<string> {
        return (await this.api.post(`/Orcamento/VerificarClienteSemAreaVenda`, {
            identificadorOrcamento,
            codigoCliente
        })).data
    }

    async ValidarAcessoCuponsDeDesconto(identificadorOrcamento: string): Promise<boolean> {
        return (await this.api.post(`/Orcamento/ValidarAcessoCuponsDeDesconto`, {
            identificadorOrcamento,
        })).data
    }

    

    async definirQuantidadeItem(
        identificadorItem: number,
        identificadorOrcamento: string,
        quantidade: number,
        quantidadeEstoque: number,
        quantidadeSolicitada: number): Promise<IOrcamento> {

           // const inicio = performance.now()

        const resposta = await this.api.post(`/Orcamento/DefinirQuantidadeItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            quantidade,
            quantidadeEstoque,
            quantidadeSolicitada
        })

        // const fim = performance.now()
        // const tempoGasto = fim - inicio
        

        //console.log(`Chamada à API Quantidade [${quantidade}] concluída. Tempo gasto: ${tempoGasto.toFixed(2)}ms`);

        return resposta?.data
    }

    async definirDescricaoItem(
        identificadorItem: number,
        identificadorOrcamento: string,
        descricao: string): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirDescricaoProdutoForaEstoqueItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificadorItem,
            descricao,
        })

        return resposta?.data
    }

    async definirAliquotaItem(
        identificadorOrcamento: string,
        identificador: number,
        aliquota: number
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirAliquotaIPIItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificador,
            aliquota,
        })

        return resposta?.data
    }

    async definirValorIPIIItem(
        identificadorOrcamento: string,
        identificador: number,
        valor: number
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirValorIPIItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificador,
            valor,
        })

        return resposta?.data
    }

    async obterEncomendaItemOrcamento(
        identificadorOrcamento: string,
        identificador: number,
    ): Promise<OrcamentoApi.ObterEncomendaItemOrcamentoResposta> {
        const resposta = await this.api.post(`/Orcamento/ObterEncomendaItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificador,
        })
 
        return resposta?.data
    }

    async lotesProduto(identificadorOrcamento: string, codigoObjetoItem: number): Promise<DadosProdutosLote> {
        const resposta = await this.api.post(`/Orcamento/LotesProduto`, {
            identificadorOrcamento,
            codigoObjetoItem,
        })

        return resposta?.data
    }

    async reservarLote(identificadorOrcamento: string, lote: Lotes): Promise<any> {
        const resposta = await this.api.post(`/Orcamento/ReservarLote`, {
            identificadorOrcamento,
            lote,
        })

        return resposta?.data
    }

    async produtosControleLote(identificadorOrcamento: string): Promise<PagedMessageResponse<DadosProdutoControleLote>> {
        const resposta = await this.api.post(`/Orcamento/ProdutosControleLote`, {
            identificadorOrcamento,
        })

        return resposta?.data
    }

    async definirEntregaPosteriorItem(
        identificadorOrcamento: string,
        identificador: number,
        entregaPosterior: boolean
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirEntregaPosteriorItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificador,
            entregaPosterior,
        })

        return resposta?.data
    }

    async listaModalidadeEntrega(
        identificadorOrcamento: string,
    ): Promise<DadosModalidadeEntrega> {
        const resposta = await this.api.post(`/Orcamento/ModalidadesEntrega`, {
            identificadorOrcamento: identificadorOrcamento,
        })

        return resposta?.data
    }

    async definirMotivoDescontoItem(
        identificadorItem: number,
        identificadorOrcamento: string,
        codigoMotivoDesconto: number
    ): Promise<DomainDataType<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/DefinirMotivoDescontoItemOrcamento`, {
            identificadorItem: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            codigoMotivoDesconto,
        })

        return resposta?.data
    }

    async editarAmbienteItem(
        identificadorItens: number[],
        identificadorOrcamento: string,
        ambiente: string
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/EditarAmbienteItem`, {
            identificadorItens,
            identificadorOrcamento: identificadorOrcamento,
            ambiente
        })

        return resposta?.data
    }

    async obterTiposFaturamentoItem(): Promise<ITipoFaturamento[]> {

        const resposta = await this.api.get('/Orcamento/_ObterTipoFaturamentoItem')

        return resposta?.data
    }

    async definirTransportadora(
        identificadorOrcamento: string,
        tipoOrcamento: number,
        transportadora: Transportadora
    ): Promise<{ UserMessage: string, Transforming: boolean, Transportadora: Transportadora, ItensOrcamento: IItemOrcamento[] }> {
        const resposta = await this.api.post(`/Orcamento/DefinirTransportadora`, {
            TipoOrcamento: tipoOrcamento,
            identificadorOrcamento,
            transportadora,
        })

        return resposta?.data
    }

    async DadosHistoricoOrcamento(numeroPedido: number, numeroPagina: number): Promise<Partial<PagedMessageResponse<DadoHistoricoOrcamento>>> {
        const resposta = await this.api.post(`/Orcamento/DadosHistoricoOrcamento`, {
            numeroPedido, numeroPagina
        })

        return resposta?.data
    }


    async definirTipoFaturamentoItem(
        identificadorItem: number,
        identificadorOrcamento: string,
        tipoFaturamento: string): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirTipoFaturamentoItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            tipoFaturamento,
        })

        return resposta?.data
    }



    async definirPrecoprodutoItem(
        identificadorItem: number,
        identificadorOrcamento: string,
        preco: number,
        percentualDesconto,
        percentualBonificacao,
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirPrecoProdutoItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            precoProduto: preco,
            percentualDesconto: percentualDesconto,
            percentualBonificacao: percentualBonificacao
        })
        return resposta?.data
    }

    async definirPrecoprodutoItemAlterandoPercentual(
        identificadorItem: number,
        identificadorOrcamento: string,
        preco: number,
        percentualDesconto,
        percentualBonificacao,
    ): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirPrecoProdutoItemOrcamentoAtualizandoPercentualDesconto`, {
            identificadorItem: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            precoProduto: preco,
            percentualDesconto: percentualDesconto,
            percentualBonificacao: percentualBonificacao
        })
        return resposta?.data
    }

    async obterSimulacaoPrecoItem(identificadorOrcamento: string, identificadorItem: number): Promise<SimulacaoPrecoItemContract> {
        const formData = new FormData()
        formData.append('identificadorOrcamento', identificadorOrcamento)
        formData.append('identificador', identificadorItem?.toString())

        const resposta = await this.api.post(`/Orcamento/SimularPrecoItemOrcamento`, formData)

        return resposta.data
    }

    async calcularMarkupPeloPrecoNaSimulacaoPrecoItem(identificadorOrcamento: string, identificadorItem: number, preco: number): Promise<Number> { // 453508
        const resposta = await this.api.post(`/Orcamento/CalcularMarkupPeloPrecoNaSimulacaoPrecoItem`, {
            identificadorItem: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            preco: preco,
        })

        return resposta?.data
    }

    async calcularPrecoPeloMarkupNaSimulacaoPrecoItem(identificadorOrcamento: string, identificadorItem: number, markup: number): Promise<Number> { // 453508
        const resposta = await this.api.post(`/Orcamento/CalcularMarkupPeloPrecoNaSimulacaoPrecoItem`, {
            identificadorItem: identificadorItem,
            identificadorOrcamento: identificadorOrcamento,
            markup: markup,
        })

        return resposta?.data
    }

    async simularDesconto(dados: OrcamentoApi.SimularDescontoRequisicao): Promise<OrcamentoApi.SimularDescontoResposta> {
        const { identificadorOrcamento, codigoObjetoItem, percentualBonificacao, percentualDesconto, percentualDescontoGeralOrcamento, preco, preservaDesconto } = dados
        const resposta = await this.api.post(`/Orcamento/SimularDescontoItemOrcamento`, {
            simularDesconto: {
                codigoObjetoItem,
                identificadorOrcamento,
                percentualBonificacao: percentualBonificacao,
                percentualDesconto: percentualDesconto,
                percentualDescontoGeralOrcamento: percentualDescontoGeralOrcamento,
                preco: preco,
                preservaDesconto: preservaDesconto === undefined ? null : preservaDesconto
            }
        })
        return resposta.data
    }


    async calcularSimulacaoPrecoItem(identificadorOrcamento: string, identificadorItem: number, dadosSimulacao: SimulacaoPrecoItemContract): Promise<SimulacaoPrecoItemContract> {
        const resposta = await this.api.post(`/Orcamento/CalcularSimulacaoPreco`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificadorItem,
            dadosSimulacao: dadosSimulacao
        })
        return resposta.data
    }

    async aplicarSimulacaoPrecoItem(identificadorOrcamento: string, identificadorItem: number, dadosSimulacao: SimulacaoPrecoItemContract): Promise<SimulacaoPrecoItemContract> {
        const resposta = await this.api.post(`/Orcamento/AplicarSimulacaoPreco`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificadorItem,
            dadosSimulacao: dadosSimulacao,
        })
        return resposta.data
    }

    async produtoAdicionadoOrcamento(identificadorOrcamento: string, produto: IItemOrcamento): Promise<boolean> {
        const resposta = await this.api.post(`/ItemOrcamento/ProdutoAdicionadoOrcamento`, {
            identificadorOrcamento,
            produto
        });

        return resposta.data;
    }

    async GerarHistoricoLiberacaoPendencia(numeroPedido: number, textoHistorico: string, senhaLiberacao: string, tipoLiberacao: string): Promise<void> { // 450413        
        await this.api.post(`/Orcamento/GerarHistoricoLiberacaoPendencia`, {
            numeroPedido: numeroPedido,
            textoHistorico: textoHistorico,
            senhaLiberacao: senhaLiberacao,
            tipoLiberacao: tipoLiberacao
        });

        return ;
    }

    async validarSenha(senha: string, permissao: string): Promise<DomainDataType<any>> {
        const resposta = await this.api.post(`/Orcamento/ValidarPermissaoSenhaVenda`, {
            senha: senha,
            permissao: permissao
        })

        return resposta.data
    }


    async obterItensTotaisOrcamento(identificadorOrcamento: string): Promise<IOrcamento> {
        const resposta = await this.api.get(`/Orcamento/ObterItensTotaisOrcamento`, {
            params: {
                identificadorOrcamento
            }
        })

        return resposta.data
    }

    async obterListaFiliais(identificadorOrcamento: string, identificadorItem: number, tipo: string): Promise<IFilial[]> {

        const resposta = await this.api.get(`_ObterListaFiliaisItem`, {
            params: {
                identificadorOrcamento,
                identificadorItem,
                tipo
            }
        })

        return resposta.data
    }

    async definirOidModalidadeEntregaItem(identificadorOrcamento: string, identificadorItem: number, oidModalidadeEntrega: number): Promise<IOrcamento> { // 402445
        const response = await this.api.post(`/Orcamento/DefinirOidModalidadeEntregaItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            oidModalidadeEntrega,
        })
        return response.data
    }

    async definirIdPontoRetiradaItem(identificadorOrcamento: string, identificadorItem: number, idPontoRetirada: number): Promise<IOrcamento> { // 402445
        const response = await this.api.post(`/Orcamento/DefinirIdPontoRetiradaItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            idPontoRetirada,
        })

        return response.data
    }

    async definirFilialRetirada(identificadorOrcamento: string, identificadorItem: number, codigoFilialRetirada: string): Promise<IOrcamento> {
        const response = await this.api.post(`/Orcamento/DefinirFilialRetiradaItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            codigoFilialRetirada,
        })

        return response.data
    }

    async definirFilialTransferencia(identificadorOrcamento: string, identificadorItem: number, codigoFilialTransferencia: string): Promise<IOrcamento> {
        const response = await this.api.post(`/Orcamento/DefinirFilialTransferenciaItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            codigoFilialTransferencia,
        })

        return response.data
    }

    async definirPedidoCompraItem(identificadorOrcamento: string, identificadorItem: number, pedidoCompra: string): Promise<IOrcamento> {
        const response = await this.api.post(`/Orcamento/DefinirPedidoCompraItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            pedidoCompra,
        })

        return response.data
    }

    async alterarEmailPixPrazoNoOrcamento(identificadorOrcamento: string, emailPixPrazo: string): Promise<void> { // 4146208
        const resposta = await this.api.post(`/Orcamento/AlterarEmailPixPrazoNoOrcamento`, {
            identificadorOrcamento,
            emailPixPrazo,
        })
        return
    }

    async obterCentroCusto(identificadorOrcamento: string, nomeCentroCusto: string): Promise<ICentroCusto[]> {

        const resposta = await this.api.get(`/Orcamento/_ObterCentroCustoCliente`, {
            params: {
                identificadorOrcamento,
                nomeCentroCusto
            }
        })

        return resposta.data
    }

    async definirCentroCustoItemOrcamento(identificadorOrcamento: string, identificadorItem: number, idCentroCusto: number): Promise<IOrcamento> {

        const resposta = await this.api.post(`/Orcamento/DefinirIdCentroCustoItemOrcamento`, {
            identificadorOrcamento,
            identificador: identificadorItem,
            idCentroCusto
        })

        return resposta.data
    }

    // 412949 - async alterarFonte(tamanho:number) : Promise<void> {
    //
    //     const response = await this.api.post(`/Usuario/TamanhoFonteGrid`, {
    //         tamanho,
    //         //TODO: buscar o idGrid dinamicamente
    //         idGrid: 2
    //     })
    //     return response.data
    // }

    async alterarFonte(tamanho: number): Promise<void> {
        const response = await this.api.post(`/Usuario/TamanhoFonteGridPeloNome`, {
            tamanho,
            nomeGrid: "ITENS_ORCAMENTO", // 412949
            nomeModulo: "Orcamento"
        })
        return response.data
    }

    async obterTamanhoFonte(): Promise<number> {

        const resposta = await this.api.post(`/Usuario/_ObterTamanhoFonteGrid`, {
            nomeGrid: "ITENS_ORCAMENTO",
            modulo: "Orcamento"
        })

        return resposta.data
    }

    async obterPermiteAcessoEngrenagemGrid(): Promise<boolean> {
        const response = await this.api.post(`/Usuario/Permitido`, {
            funcionalidade: "ORCAMENTO_ACESSO_ENGRENAGEM_GRID", // 418506
            nomeModulo: "Orcamento"
        })
        return response.data != null && response.data
    }
    async excluirItens(identificadorOrcamento: string, itens: IItemOrcamento[]): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/ExcluirItens`, {
            identificadorOrcamento,
            itens
        })

        return resposta.data
    }


    async adicionarProdutosForaEstoque(identificadorOrcamento: string, produtos: DadosTabelaProdutosForaEstoque[]): Promise<ItensTotaisOrcamento> {
        const resposta = await this.api.post(`/Orcamento/AdicionarProdutosForaEstoque`, {
            identificadorOrcamento,
            produtos
        })

        return resposta.data
    }


    async alterarTipoEntregaItens(
        identificadorOrcamento: string,
        alterarTipoEntregaPadraoOrcamento: boolean,// 474918
        tipoEntrega: string,
        itens: IItemOrcamento[]): Promise<DomainDataType<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/AlterarTipoEntregaItens`, {
            identificadorOrcamento,
            alterarTipoEntregaPadraoOrcamento,// 474918
            tipoEntrega,
            itens
        })

        return resposta.data

    }

    async alterarTipoEntregaItem(identificadorOrcamento: string, codigoTipoEntrega: string, identificador): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirTipoEntregaItemOrcamento`, {
            codigoTipoEntrega, identificador, identificadorOrcamento
        })

        return resposta.data
    }

    async reordenarOrcamento(
        identificadorOrcamento: string,
        itens: IItemOrcamento[]
    ): Promise<IItemOrcamento[]> {
        const resposta = await this.api.post(`/Orcamento/ReordenarItens`, {
            identificadorOrcamento,
            itens
        })

        return resposta.data
    }

    async ListarFiliaisAutorizadasExibirQuantidadeEstoqueGridOrcamento(): Promise<string[]> {
        const resposta = await this.api.get(`/Orcamento/ListarFiliaisAutorizadasExibirQuantidadeEstoqueGridOrcamento`)
        return resposta.data
    }

    async ObterDadosPesquisaOrcamento(): Promise<DadosPesquisaOrcamento> {
        
        const resposta = await this.api.get(`/Orcamento/ObterDadosPesquisaOrcamento`)
        
        return resposta.data
    }

    async PesquisarOrcamento(filtros: Partial<FiltroPesquisaOrcamento>): Promise<DadosTotalDaPesquisaOrcamento> {
        const resposta = await this.api.post(`/Orcamento/PesquisarOrcamento`, {
            filtros
        })

        return resposta.data
    }

    async ObterDadosCancelarOrcamento(numeroPedido: number, tipoOrcamento: string): Promise<DadosCancelarOrcamento> {
        const resposta = await this.api.post(`/Orcamento/ObterDadosCancelarOrcamento`, {
            numeroPedido, tipoOrcamento
        })

        return resposta.data
    }

    async CancelarOrcamento(numeroPedido: number, itensACancelar: Partial<ItensACancelar>, codigoCliente?: number): Promise<PedidoCancelado> {
        const resposta = await this.api.post(`/Orcamento/CancelarOrcamento`, {
            numeroPedido, itensACancelar, codigoCliente
        })

        return resposta.data
    }

    async LiberarAutorizacaoPendenciaCancelarOrcamento(numeroPedido: number, senha: string): Promise<boolean> {
        const resposta = await this.api.post(`/Orcamento/LiberarAutorizacaoPendenciaCancelarOrcamento`, {
            numeroPedido, senha
        })

        return resposta.data
    }

    async VerificarAutorizacaoCancelarOrcamento(numeroPedido: number, itensACancelar: Partial<ItensACancelar>): Promise<NecessitaAutorizacaoExclusaoFinanceiro> {
        const resposta = await this.api.post(`/Orcamento/VerificarAutorizacaoCancelarOrcamento`, {
            numeroPedido, itensACancelar
        })

        return resposta.data
    }

    async ObterListaFiliaisOrcamento(CodigoFilialIgnorar: string, filialPesquisa?: string): Promise<IFilial[]> {
        
        const resposta = await this.api.get(`/Orcamento/_ObterListaFiliais`, {
            params: {
                CodigoFilialIgnorar, filialPesquisa
            }
        })

        return resposta.data
    }

    async ObterDadosTrocarFilialOrcamento(numeroPedido: number): Promise<DadosTrocarFilialOrcamento> {
        const resposta = await this.api.post(`/Orcamento/ObterDadosTrocarFilialOrcamento`, {
            numeroPedido
        })

        return resposta.data
    }

    async TrocarFilial(numeroPedido: number, codigoNovaFilial: string, oidFilialPedido: number, senhaAutorizacao: string): Promise<boolean> {
        const resposta = await this.api.post(`/Orcamento/TrocarFilial`, {
            numeroPedido, codigoNovaFilial, oidFilialPedido, senhaAutorizacao
        })

        return resposta.data
    }

    async EditarUltimoOrcamentoVendedor(): Promise<any> {
        const resposta = await this.api.post(`/Orcamento/EditarUltimoOrcamentoVendedor`,)

        return resposta.data
    }


    async alterarDataPrevisaoEntregaItem(identificador: number, dataPrevisaoEntrega: string, identificadorOrcamento: string): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirDataPrevisaoEntregaItemOrcamento`, {
            dataPrevisaoEntrega, identificador, identificadorOrcamento
        })

        return resposta.data
    }

    async alterarDataMarcadaEntregaItem(identificador: number, dataMarcadaEntrega: string, identificadorOrcamento: string): Promise<DomainDataType<IOrcamento>> {
        const resposta = await this.api.post(`/Orcamento/DefinirDataMarcadaEntregaItemOrcamento`, {
            dataMarcadaEntrega, identificador, identificadorOrcamento
        })

        return resposta.data
    }

    async alterarRegimeEspecialItem(identificadorOrcamento: string, identificador: number, desativaRegimeEspecial: boolean): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirDesativaRegimeEspecialItemOrcamento`, {
            identificadorOrcamento, identificador, desativaRegimeEspecial
        })

        return resposta.data
    }

    async substituirDataMarcadaDataPrevisaoEntregaItens(identificadorOrcamento: string, dataMarcadaEntrega: string): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/SubstituirDataMarcadaDataPrevisaoEntregaItens`, {
            dataMarcadaEntrega, identificadorOrcamento
        }, {
            mostrarMensagensUsuario: true
        } as AxiosRequestConfig & any)



        return resposta.data
    }

    async definirTurnoEntregaItem(identificadorOrcamento: string, identificador: number, turnoEntrega: CodigoTurnoEntrega): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirTurnoEntregaItemOrcamento`, {
            identificadorOrcamento, identificador, turnoEntrega
        })

        return resposta.data
    }

    async definirVendaSobEncomendaItem(identificadorOrcamento: string, identificador: number, vendaSobEncomenda: boolean): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirVendaSobEncomendaItemOrcamento", {
            identificadorOrcamento, identificador, vendaSobEncomenda
        })

        return resposta.data
    }

    async definirEncomendaExpressaItem(identificadorOrcamento: string, identificador: number, encomendaExpressa: boolean): Promise<IOrcamento> {  // 433263
        const resposta = await this.api.post("/Orcamento/DefinirEncomendaExpressaItemOrcamento", {
            identificadorOrcamento, identificador, encomendaExpressa
        })
        return resposta.data
    }

    async definirPrioridadeMontagemItem(identificadorOrcamento: string, identificador: number, prioridadeMontagem: boolean): Promise<IOrcamento> {  // 456839
        const resposta = await this.api.post("/Orcamento/DefinirPrioridadeMontagemItemOrcamento", {
            identificadorOrcamento, identificador, prioridadeMontagem
        })
        return resposta.data
    }

    async definirMostruarioItemOrcamento(identificadorOrcamento: string, identificador: number, mostruario: boolean): Promise<IOrcamento> { // PA 487087
        const resposta = await this.api.post("/Orcamento/DefinirMostruarioItemOrcamento", {
            identificadorOrcamento, identificador, mostruario
        })
        return resposta.data
    }

    async definirDespesasInclusas(identificadorOrcamento: string, valorDespesasInclusas: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirDespesasInclusas", {
            identificadorOrcamento,
            valorDespesasInclusas
        })

        return resposta.data
    }

    async definirPercentualDescontoAcumulado(identificadorOrcamento: string, percentualDescontoAcumulado: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirPercentualDescontoAcumulado", {
            identificadorOrcamento,
            percentualDescontoAcumulado
        })

        return resposta.data
    }

    async definirPercentualSeguroEntrega(identificadorOrcamento: string, percentualSeguroEntrega: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirPercentualSeguroEntrega", {
            identificadorOrcamento,
            percentualSeguroEntrega
        })

        return resposta.data
    }

    async definirPercentualFrete(identificadorOrcamento: string, percentualFrete: number): Promise<IOrcamento> { //445689
        const resposta = await this.api.post("/Orcamento/DefinirPercentualFrete", {
            identificadorOrcamento,
            percentualFrete
        })

        return resposta.data
    }

    async definirValorFrete(identificadorOrcamento: string, valorFrete: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirValorFrete", {
            identificadorOrcamento,
            valorFrete
        })

        return resposta.data
    }

    async definirValorSeguroEntrega(identificadorOrcamento: string, valorSeguroEntrega: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirValorSeguroEntrega", {
            identificadorOrcamento,
            valorSeguroEntrega
        })

        return resposta.data
    }

    async buscarDadosFinalizarOrcamento(dados: IOrcamento): Promise<any> {
        const resposta = await this.api.get("/Orcamento/ObterDadosFinalizarOrcamento", {
            params: {
                identificadorOrcamento: dados.IdentificadorOrcamento,
                valorOrcamento: dados.ValorTotalMercadorias,
                verificarPendenciaFormaDePagamento: dados.VerificarPendenciaFormaDePagamento,
                codigoFilialOrcamento: dados.CodigoFilialOrcamento,
                codigoCliente: dados.CodigoCliente,
                tipoTransportadora: dados.Transportadora?.TipoTransportadora,
                valorFrete: dados.ValorFrete,
                verificarPendenciaVendaFrete: dados.VerificarPendenciaVendaFrete
            }
        })
        return resposta.data
    }

    async definirNovaDataCapacidadeCarga(FilialCapacidadeCargaEncaixe: string, dataPrevisaoEntrega: string): Promise<any> {
        const resposta = await this.api.post("/Orcamento/ConfirmarNovaDataPrevisaoEntregaEncaixeItemOrcamento", {
            FilialCapacidadeCargaEncaixe,
            dataPrevisaoEntrega,
            listidentificador: [],
            listidentificadorOrcamento: []
        })
        return resposta.data
    }

    async liberarPendencias(
        identificadorOrcamento: string,
        motivoLiberacaoPendencia?: string,
        senhaLiberacaoPendencia?: string
    ): Promise<LiberarPendenciaResposta> {
        const resposta = await this.api.post("/Orcamento/LiberarPendencias", {
            identificadorOrcamento,
            motivoLiberacaoPendencia,
            senhaLiberacaoPendencia
        })
        return resposta.data
    }


    async definirNumeroComanda(identificadorOrcamento: string, numeroComanda?: string): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirNumeroComanda", {
            identificadorOrcamento, numeroComanda
        })
        return resposta.data
    }

    async salvar(orcamento: IOrcamento): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/Salvar", {
            orcamento
        })
        return resposta.data
    }

    async responderPerguntas(identificadorOrcamento: string, perguntas: TipoInconsistencia[]): Promise<IOrcamento> { // 436006
        const resposta = await this.api.post("/Orcamento/ResponderPerguntas", {
            identificadorOrcamento,
            perguntas,
        })
        return resposta.data
    }

    async atualizarCliente(identificadorOrcamento: string, codigoCliente: number, senha?: string, senhaVendedorRelacionado?: string, senhaClienteComLimiteCreditoBloqueado?: string, validarCliente?: boolean): Promise<DomainDataType<IOrcamento> | DomainDataPendenciaCliente> {
        const resposta = await this.api.post("/Orcamento/AtualizarCliente", {
            identificadorOrcamento,
            codigoCliente,
            senha,
            senhaVendedorRelacionado,
            senhaClienteComLimiteCreditoBloqueado, // 436006
            validarCliente
        })
        return resposta.data
    }

    async definirDespesasInclusasItemOrcamento(despesasInclusas: boolean, identificador: number, identificadorOrcamento: string): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDespesasInclusasItemOrcamento`, {
            despesasInclusas, identificador, identificadorOrcamento
        })).data
    }

    async definirMarkUpProdutoItemOrcamento(identificadorItem: number, identificadorOrcamento: string, markupPretendido: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirMarkUpProdutoItemOrcamento`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            markupPretendido
        }))?.data
    }

    async possuiPermissaoInformarLinhaPedidoCompra(identificadorOrcamento: string): Promise<boolean> {
        return (await this.api.get(`/Orcamento/PossuiPermissaoInformarLinhaPedidoCompra`, {
            params: {
                identificadorOrcamento
            }
        }))?.data
    }

    async alterarOrdemPedidoCompraCliente(identificadorItem: number, identificadorOrcamento: string, ordemPedidoCompraCliente: string): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/AlterarPedidoCompraCliente`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            numPedidoCompraCliente: ordemPedidoCompraCliente
        }))?.data
    }

    async definirOfertaSeletivaItem(identificadorItem: number, identificadorOrcamento: string, ofertaSelecionada: boolean): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirOfertaSeletiva`, {
            identificador: identificadorItem,
            identificadorOrcamento,
            ofertaSelecionada: ofertaSelecionada ? 1 : 0
        }))?.data
    }

    async definirEntregaPosteriorItensOrcamento(identificadorOrcamento: string, identificadores: number[], entregaPosterior: boolean): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirEntregaPosteriorItensOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificadores,
            entregaPosterior,
        })

        return resposta?.data
    }

    async definirValorDescontoAcumulado(identificadorOrcamento: string, valorDescontoAcumulado: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirValorDescontoAcumulado`, {
            identificadorOrcamento,
            valorDescontoAcumulado
        }))?.data
    }

    async DefinirPercentualSeguroEntrega(identificadorOrcamento: string, percentual: string): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirPercentualSeguroEntrega`, {
            identificadorOrcamento,
            percentualSeguroEntrega: percentual
        }))?.data
    }

    async DefinirValorSeguroEntrega(identificadorOrcamento: string, valorSeguro: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirValorSeguroEntrega`, {
            identificadorOrcamento,
            valorSeguroEntrega: valorSeguro
        }))?.data
    }

    async DefinirPercentualDesconto(identificadorOrcamento: string, percentualDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirPercentualDesconto`, {
            identificadorOrcamento,
            percentualDesconto
        }))?.data
    }

    async DefinirValorDesconto(identificadorOrcamento: string, valorDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirValorDesconto`, {
            identificadorOrcamento,
            valorDesconto
        }))?.data
    }

    async DefinirValorAcrescimoFinanceiro(identificadorOrcamento: string, valorAcrescimoFinanceiro: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirValorAcrescimoFinanceiro`, {
            identificadorOrcamento,
            valorAcrescimoFinanceiro
        }))?.data
    }

    async DefinirPercentualDescontoSobreMercadoriasImportadas(identificadorOrcamento: string, percentualDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "PercentualDescontoImportado",
            valor: percentualDesconto
        }))?.data
    }

    async DefinirValorDescontoAcumuladoSobreMercadoriasNacionais(identificadorOrcamento: string, valorDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoAcumuladoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "ValorDescontoAcumuladoNacional",
            valor: valorDesconto
        }))?.data
    }

    async DefinirPercentualDescontoAcumuladoSobreMercadoriasNacionais(identificadorOrcamento: string, percentualDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoAcumuladoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "PercentualDescontoAcumuladoNacional",
            valor: percentualDesconto
        }))?.data
    }

    async DefinirPercentualDescontoAcumuladoSobreMercadoriasImportadas(identificadorOrcamento: string, percentualDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoAcumuladoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "PercentualDescontoAcumuladoImportado",
            valor: percentualDesconto
        }))?.data
    }

    async DefinirPercentualDescontoSobreMercadoriasNacionais(identificadorOrcamento: string, percentualDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "PercentualDescontoNacional",
            valor: percentualDesconto
        }))?.data
    }

    async DefinirValorDescontoSobreMercadoriasImportadas(identificadorOrcamento: string, valorDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "ValorDescontoImportado",
            valor: valorDesconto
        }))?.data
    }

    async DefinirValorDescontoSobreMercadoriasNacionais(identificadorOrcamento: string, valorDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirDescontoSobreMercadorias`, {
            identificadorOrcamento,
            tipo: "ValorDescontoNacional",
            valor: valorDesconto
        }))?.data
    }

    async listarItensOrcamento(identificadorOrcamento: string): Promise<RespostaConsultaItensOrcamento> {
        return (await this.api.post('/Orcamento/ListarItensOrcamento', {
            identificadorOrcamento
        }))?.data
    }


    async listarTipoEntrega(): Promise<ListarTipoEntrega[]> {
        const resposta = await this.api.post(`/Orcamento/ListarTiposEntrega`);
        return resposta.data;
    }


    async listarFiliaisRetirada(): Promise<IFilial[]> {
        //430346 -- const resposta = await this.api.post(`/Orcamento/ListarFiliais`);
        const resposta = await this.api.post(`/Orcamento/ListarFiliaisRetirada`); // 430346
        return resposta.data;
    }

    async obterFilialPorOid(oidFilial: number) : Promise<IFilial> {
        const resposta = await this.api.get(`/Orcamento/ObterFilialPorOid`, {
            params: {
                oidFilial
            }
        })
        return resposta.data;
    }

    async obterDadosFormaPagamento({
        identificadorOrcamento, codigoFormaPagamento, codigoTipoDocumento, valorOrcamento, verificarPendenciaFormaDePagamento, removerItensOuValoresModificados
    }: { identificadorOrcamento: string, codigoFormaPagamento: number, codigoTipoDocumento: number, valorOrcamento: number, 
                verificarPendenciaFormaDePagamento: boolean, removerItensOuValoresModificados?: boolean }
            ): Promise<ObterDadosFormaPagamentoResposta> {

        var retorno = await this.api.get(`/Orcamento/ObterDadosFormaPagamento`, {
            params: {
                identificadorOrcamento,
                codigoFormaPagamento,
                codigoTipoDocumento,
                valorOrcamento,
                verificarPendenciaFormaDePagamento,
                removerItensOuValoresModificados,  // para informar q o usuario ha viu  as parcelas alteradas
            }
        })
        
        return retorno.data
    }

    async obterDadosEntrega({ identificadorOrcamento, tipoOrcamento, codigofilialVenda }: { identificadorOrcamento: string, tipoOrcamento: number, codigofilialVenda: string }): Promise<DadosEntrega> {
        return (await this.api.get(`/Orcamento/ObterDadosEntrega`, {
            params: {
                identificadorOrcamento,
                tipoOrcamento,
                codigofilialVenda,
            }
        })).data
    }

    async obterDadosDestinoTransferencia(identificadorOrcamento: string): Promise<DadosDestinoTransferencia> {
        return (await this.api.get(`/Orcamento/ObterDadosDestinoTransferencia`, {
            params: {
                identificadorOrcamento,
            }
        })).data
    }

    async salvarDadosFaturamentoTransferencia(identificadorOrcamento: string, dadosDestinoTransferencia: DadosDestinoTransferencia): Promise<DadosDestinoTransferencia> {
        return (await this.api.post(`/Orcamento/SalvarDadosFaturamentoTransferencia`, {
            identificadorOrcamento,
            dadosDestinoTransferencia,
        })).data
    }

    async obterDadosTransportadora({ identificadorOrcamento, tipoOrcamento }: { identificadorOrcamento: string, tipoOrcamento: number }): Promise<DadosTransportadora> {
        return (await this.api.get(`/Orcamento/ObterDadosTransportadora`, {
            params: {
                identificadorOrcamento,
                tipoOrcamento,
            }
        })).data
        
    }

    async ListarFretes(identificadorOrcamento: string): Promise<Frete[]> {
        return (await this.api.get(`/Orcamento/ListarFretes`, {
            params: {
                identificadorOrcamento,
                NumeroPagina: 1,
                TamanhoPagina: 20
            },
            mostrarMensagensUsuario: false
        } as AxiosRequestConfig)).data?.Entities
    }

    async ObterOpcoesEntrega(): Promise<{ "OpcoesEntrega": OpcaoEntrega[] }> {
        return (await this.api.get(`/Orcamento/ObterOpcoesEntrega`)).data
    }

    async definirTipoEntrega(identificadorOrcamento: string, tipoEntrega: TipoEntrega) {
        return (await this.api.post(`/Orcamento/DefinirTipoEntregaCargaItemOrcamento`, {
            identificadorOrcamento,
            tipoEntrega
        })).data
    }

    async definirFreteCarga(identificadorOrcamento: string, frete: Frete) {
        return (await this.api.post(`/Orcamento/DefinirFreteCarga`, {
            identificadorOrcamento,
            frete
        })).data
    }

    async ReplicarDataEntrega(dados: Entrega, alterarDataPrevista: boolean): Promise<ItensTotaisOrcamento> {
        return (await this.api.post(`/Orcamento/ReplicarDatas`, {
            atualizarEntrega: dados,
            alterarDataPrevista
        })).data
    }

    async ListarTiposEntrega(identificadorOrcamento: string): Promise<TipoEntrega[]> {
        return (await this.api.get(`/Orcamento/ListarTiposEntrega`, {
            params: {
                identificadorOrcamento,
            },
            mostrarMensagensUsuario: false
        } as AxiosRequestConfig)).data?.Dados?.Entities
    }

    async atualizarFormaPagamento({
        codigoFormaPagamento, codigoTipoDocumento, identificadorOrcamento, valorOrcamento, verificarPendenciaFormaDePagamento
    }: {
        codigoFormaPagamento: number,
        codigoTipoDocumento: number,
        identificadorOrcamento: string,
        valorOrcamento: number,
        verificarPendenciaFormaDePagamento: boolean
    }): Promise<Omit<IOrcamento, "ItensOrcamento">> {
        return (await this.api.post(`/Orcamento/AtualizarFormaPagamento`, {
            codigoFormaPagamento,
            codigoTipoDocumento,
            identificadorOrcamento,
            valorOrcamento,
            verificarPendenciaFormaDePagamento
        })).data
    }

    async obterTiposDocumento({
        codigoFormaPagamento,
        identificadorOrcamento
    }: {
        codigoFormaPagamento: number,
        identificadorOrcamento: string
    }): Promise<ObterTiposDocumentoResposta> {
        return (await this.api.post(`/Orcamento/TiposDocumento`, {
            codigoFormaPagamento,
            identificadorOrcamento
        })).data
    }

    async atualizarRecalcularParcelas(identificadorOrcamento: string, recalcular: boolean):Promise<boolean> {
        return await this.api.post(`/Orcamento/AtualizarRecalcularParcelas`, {
            identificadorOrcamento,
            recalcular
        })
    }

    async excluirParcelas(identificadorOrcamento: string, codigosParcelas: number[]) {
        await this.api.post(`/Orcamento/ExcluirParcelas`, {
            identificadorOrcamento,
            parcelas: codigosParcelas.map(codigoParcela => ({
                Codigo: codigoParcela
            }))
        })
    }

    async obterDadosParaInsercaoEdicaoParcela(identificadorOrcamento: string): Promise<ObterDadosParaInsercaoEdicaoParcelaResposta> {
        /*
        return (await this.api.get(`/Orcamento/ObterDadosParaInsercaoEdicaoParcela`, {
            params: {
                identificadorOrcamento
            }
        })).data
        */
        var retorno =await this.api.get(`/Orcamento/ObterDadosParaInsercaoEdicaoParcela`, {
            params: {
                identificadorOrcamento
            }
        })
        
        return retorno.data
    }

    async atualizarParcela(identificadorOrcamento: string, dadosParcela: DadosParcela[]): Promise<AtualizarParcelaResposta> {
        /*
        return (await this.api.post(`/Orcamento/AtualizarParcela`, {
            identificadorOrcamento,
            parcela: dadosParcela
        })).data
        */
        var retorno = await this.api.post(`/Orcamento/AtualizarParcela`, {
            identificadorOrcamento,
            parcela: dadosParcela
        })
        return retorno.data
    }

    async AutorizarAcoesOrcamento(tipoOrcamento: string, acao: string, validarFonteReceita: boolean = false, oidFilial: number | null = null, codigoFilial: string | null): Promise<any> {
        
        return (await this.api.post(`/Orcamento/AutorizarAcoesOrcamento`, {
            tipoOrcamento,
            acao,
            validarFonteReceita, // 487678
            oidFilial, // 487678
            codigoFilial // 487678
        })).data
    }

    async AutorizarDuplicacaoOrcamento(numeroPedido: number, tipoOrcamento: string): Promise<any> {
        return (await this.api.post(`/Orcamento/AutorizarDuplicacaoOrcamento`, {
            numeroPedido,
            tipoOrcamento,
        })).data
    }

    async obterDadosPlanoPagamento(identificadorOrcamento: string): Promise<DomainDataType<ObterDadosPlanoPagamentoResposta>> {
        return (await this.api.get(`/Orcamento/ObterDadosPlanoPagamento`, {
            params: {
                identificadorOrcamento
            }
        })).data
    }

    async listarIndicadores(filtros: FiltroListarIndicador): Promise<PagedMessageResponse<Indicadores>> {
        return (await this.api.post(`/Orcamento/ListarIndicadores`, {

            filtros

        })).data
    }

    async removerIndicador(identificadorOrcamento: string) {
        return (await this.api.post(`/Orcamento/RemoverIndicador`, {

            identificadorOrcamento

        })).data
    }

    async obterDadosCadastroIndicador(codigoIndicador: number): Promise<CadastroIndicador> {
        return (await this.api.post(`/Orcamento/ObterDadosCadastroIndicador`, {
            codigoIndicador
        })).data
    }

    async adicionarVendedores(identificadorOrcamento: string, vendedores: Vendedor[]): Promise<DadosIncluirVendedores> {
        return (await this.api.post(`/Orcamento/AdicionarVendedores`, {
            identificadorOrcamento, vendedores
        })).data
    }

    async listarVendedores(filtros: FiltroListarVendedores): Promise<PagedMessageResponse<Vendedor>> {
        return (await this.api.post(`/Orcamento/ListarVendedores`, {
            filtros
        })).data
    }

    async removerVendedores(identificadorOrcamento: string, vendedores: Vendedor[]): Promise<DadosIncluirVendedores> {
        return (await this.api.post(`/Orcamento/RemoverVendedores`, {
            identificadorOrcamento, vendedores
        })).data
    }

    async listarProfissionais(filtros: FiltroListarProfissionais): Promise<PagedMessageResponse<ProfissionalComissoes>> {
        return (await this.api.post(`/Orcamento/ListarProfissionais`, {
            filtros
        })).data
    }
    async adicionarProfissionais(identificadorOrcamento: string, profissionais: ProfissionalComissoes[]): Promise<DadosIncluirProfissionais> {
        return (await this.api.post(`/Orcamento/AdicionarProfissionais`, {
            identificadorOrcamento, profissionais
        })).data
    }

    async salvarProfissionais(identificadorOrcamento: string, profissionais: ProfissionalComissoes[]): Promise<DadosIncluirProfissionais> {
        return (await this.api.post(`/Orcamento/SalvarProfissionais`, {
            identificadorOrcamento, profissionais
        })).data
    }

    async removerProfissionais(identificadorOrcamento: string, profissionais: ProfissionalComissoes[]): Promise<DadosIncluirProfissionais> {
        return (await this.api.post(`/Orcamento/RemoverProfissionais`, {
            identificadorOrcamento, profissionais
        })).data
    }

    async obterIndicador(identificadorOrcamento: string, codigoIndicador: number): Promise<DetalhesComissoes> {
        return (await this.api.post(`/Orcamento/ObterIndicador`, {
            identificadorOrcamento, codigoIndicador
        })).data
    }

    async definirIndicador(identificadorOrcamento: string, Indicador: DetalhesComissoes): Promise<DetalhesComissoes> {
        return (await this.api.post(`/Orcamento/DefinirIndicador`, {
            identificadorOrcamento, Indicador
        })).data
    }

    async salvarIndicador(Indicador: IIndicador): Promise<IIndicador> {
        return (await this.api.post(`/Orcamento/SalvarIndicador`, {
            Indicador
        })).data
    }

    async obterProgramasDeRelacionamento(): Promise<ProgramaDeRelacionamento[]> {
        return (await this.api.get(`/Orcamento/ObterProgramasDeRelacionamento`)).data
    }
    
    async definirPercentualComissaoDiferenciada(identificadorOrcamento: string, valor: number): Promise<number> {
        return (await this.api.post(`/Orcamento/DefinirPercentualComissaoDiferenciada`, {
            identificadorOrcamento, valor
        })).data
    }

    async RemoverCliente(identificadorOrcamento: string): Promise<Partial<IOrcamento>> {
        return (await this.api.post(`/Orcamento/RemoverCliente`, {
            identificadorOrcamento,
        })).data
    }

    async listarParcelasPlanoPagamento(identificadorOrcamento: string, codigoPlanoPagamento: string): Promise<ListarParcelasPlanoPagamentoRespostaItem[]> {
        return (await this.api.get(`/Orcamento/ListarParcelasPlanoPagamento`, {
            params: {
                identificadorOrcamento,
                codigoPlanoPagamento
            }
        })).data
    }

    async definirPlanoPagamento(identificadorOrcamento: string, codigoPlanoPagamento: string): Promise<DefinirPlanoPagamentoResposta> {
        return (await this.api.post(`/Orcamento/DefinirPlanoPagamento`, {
            identificadorOrcamento,
            codigoPlanoPagamento
        })).data
    }

    async removerPlanoPagamento(identificadorOrcamento: string): Promise<RemoverPlanoPagamentoResposta> {
        return (await this.api.post(`/Orcamento/RemoverPlanoPagamento`, {
            identificadorOrcamento
        })).data
    }

    async listarCarenciasParcelaPlanoPagamento(identificadorOrcamento: string, codigoNumeroParcelas: number): Promise<ListarCarenciasParcelaPlanoPagamentoRespostaItem[]> {
        return (await this.api.post(`/Orcamento/ListarCarenciasParcelaPlanoPagamento`, {
            identificadorOrcamento,
            codigoParcela: codigoNumeroParcelas
        })).data
    }

    async definirParcelaPlanoPagamento(identificadorOrcamento: string, codigoNumeroParcelas: number): Promise<DefinirPlanoPagamentoResposta> {
        return (await this.api.post(`/Orcamento/DefinirParcelaPlanoPagamento`, {
            identificadorOrcamento,
            codigoParcela: codigoNumeroParcelas
        })).data
    }

    async definirCarenciaPlanoPagamento(identificadorOrcamento: string, codigoCarencia: number): Promise<DefinirPlanoPagamentoResposta> {
        return (await this.api.post(`/Orcamento/DefinirCarenciaPlanoPagamento`, {
            identificadorOrcamento,
            codigoCarencia
        })).data
    }

    async gerarParcelasPlanoPagamento(identificadorOrcamento: string, dados: GerarParcelasPlanoPagamentoRequisicao): Promise<DefinirPlanoPagamentoResposta> {
        return (await this.api.post(`/Orcamento/GerarParcelasPlanoPagamento`, {
            ...dados,
            identificadorOrcamento
        })).data
    }

    async atualizarParcelaContrato(identificadorOrcamento: string, parcela: AtualizarParcelaContratoRequisicao): Promise<DefinirPlanoPagamentoResposta["Contrato"]["ParcelasFinanciamento"][0]> {
        /*
        return (await this.api.post(`/Orcamento/AtualizarParcelaContrato`, {
            identificadorOrcamento,
            parcela
        })).data
        */
       
       var retorno = await this.api.post(`/Orcamento/AtualizarParcelaContrato`, {
            identificadorOrcamento,
            parcela
        })
        
        return retorno.data
    }

    async listarParcelasPlanoPagamentoPorCodigo(codigoPlanoPagamento: string): Promise<ListarParcelasPlanoPagamentoPorCodigoRespostaItem[]> {
        return (await this.api.post(`/Orcamento/ListarParcelasPlanoPagamentoPorCodigo`, {
            codigoPlanoPagamento
        })).data
    }

    async listarCarenciasParcelaPlanoPagamentoPorCodigo(codigoParcela: number) {
        return (await this.api.post(`/Orcamento/ListarCarenciasParcelaPlanoPagamentoPorCodigo`, {
            codigoParcela
        })).data
    }

    async simularFinanciamento(dados: SimularFinanciamentoRequisicaoResposta): Promise<SimularFinanciamentoRequisicaoResposta> {
        return (await this.api.post(`/Orcamento/SimularFinanciamento`, dados)).data
    }

    async listarTiposDocumentoEntrada(identificadorOrcamento: string): Promise<ListarTiposDocumentoEntradaRespostaItem[]> {
        return (await this.api.post(`/Orcamento/ListarTiposDocumentoEntrada`, {
            identificadorOrcamento
        })).data
    }


    async removerFormaPagamento(identificadorOrcamento: string): Promise<Partial<IOrcamento>> {
        return (await this.api.post(`/Orcamento/RemoverFormaPagamento`, {
            identificadorOrcamento
        })).data
    }

    async igualarParcelasPrazo(identificadorOrcamento: string): Promise<IgualarParcelasPrazoResposta> {
        return (await this.api.post(`/Orcamento/IgualarParcelasPrazo`, {
            identificadorOrcamento
        })).data
    }

    async recalcularPrecos(identificadorOrcamento: string, recalcular: boolean): Promise<boolean>{
       return await this.api.post(`/Orcamento/AtualizarPrecos`, {
            identificadorOrcamento,
            recalcular
        })
    }

    async AlterarDataValidadePedido(numeroOrcamento: int, novaDataValidade: string): Promise<boolean> { // 456674
        const resposta = await this.api.post(`/Orcamento/AlterarDataValidadePedido`, {
                numeroOrcamento,
                novaDataValidade,
            }
        )

        return resposta?.data === true
    }

    async ObterDadosPedidoAlterarValidade(numero: int): Promise<DadosOrcamentoAlterarValidade> { // 456674
        var resultado = await this.api.get(`/Orcamento/ObterDadosPedidoAlterarValidade`, {
            params: {
                numeroOrcamento: numero,
            }
        })

        return resultado.data
    }


    async buscarTiposFretesDisponiveis(identificadorOrcamento: string, identificadorItem: number): Promise<OrcamentoApi.BuscarTiposFretesDisponiveisItem[]> {
        return (await this.api.get(`/Orcamento/BuscarTiposFreteDisponiveis`, {
            params: {
                identificadorOrcamento,
                identificadorItem
            }
        })).data
    }

    async alterarFreteItemOrcamento(identificadorOrcamento: string, identificadorItem: number, idTipoFreteOuFreteEspecial: number, ehFreteEspecial: boolean): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/AlterarFreteItemOrcamento`, {
            identificadorOrcamento,
            identificadorItem,
            idTipoFreteOuFreteEspecial,
            ehFreteEspecial
        })).data
    }


    async alterarTipoFreteVariosItens(identificadorOrcamento: string, identificadoresItens: number[], idTipoFreteOuFreteEspecial: number, ehFreteEspecial: boolean): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/AlterarTipoFreteVariosItens`, {
            identificadorOrcamento,
            identificadoresItens,
            idTipoFreteOuFreteEspecial,
            ehFreteEspecial
        })).data
    }

    async obterMotivosDesconto(): Promise<OrcamentoApi.ObterMotivosDescontoResposta> {
        return (await this.api.get('/Orcamento/ObterMotivosDesconto'))?.data
    }


    async obterListaCanalDeVenda(): Promise<CanalDeVenda[]>
    { // 422642
        var lista = await this.api.get('/Orcamento/ObterListaCanalDeVenda')
        return Array.isArray(lista.data) ? lista.data : []
    }

    async DefinirCodigoMotivoDesconto(identificadorOrcamento: string, codigoMotivoDesconto: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirMotivoDesconto`, {
            identificadorOrcamento,
            codigoMotivoDesconto: codigoMotivoDesconto
        }))?.data

    }

    async DefinirIdCanalDeVenda(identificadorOrcamento: string, iddCanalDeVenda: number): Promise<IOrcamento> { // 422642
        var retorno = await this.api.post(`/Orcamento/DefinirIdCanalDeVenda`, {
            identificadorOrcamento,
            idCanalDeVenda: iddCanalDeVenda
        })
        return retorno?.data

    }


    async AplicarDescontoCashback(identificadorOrcamento: string, aplicar: boolean): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/AplicarDescontoCashback`, {
            identificadorOrcamento,
            aplicar
        }))?.data

    }

    async DadosEnderecoOrcamento(identificadorOrcamento: string): Promise<Endereco[]> {
        return (await this.api.post(`/Orcamento/DadosEnderecoOrcamento`, {
            identificadorOrcamento,

        })).data
    }

    async SalvarEnderecoOrcamento(identificadorOrcamento: string, enderecos: Endereco[]): Promise<SalvarEnderecoOrcamento> {
        return (await this.api.post(`/Orcamento/SalvarEnderecoOrcamento`, {
            identificadorOrcamento,
            enderecos

        })).data
    }


    async definirDataPrevisaoEntregaItensOrcamento(identificadorOrcamento: string, identificadores: number[], dataPrevisaoEntrega: any): Promise<any> {
        return (await this.api.post('/Orcamento/DefinirDataPrevisaoEntregaItensOrcamento', {
            identificadorOrcamento,
            identificadores,
            dataPrevisaoEntrega
        }))?.data
    }

    async definirObservacaoItemOrcamento(identificadorOrcamento: string, identificador: number, observacao: string): Promise<string> {
        const resposta = await this.api.post("/Orcamento/DefinirObservacaoItemOrcamento", {
            identificadorOrcamento,
            identificador,
            observacao
        })

        return resposta.data
    }


    async salvarCliente(identificadorOrcamento: string, cliente: ICliente): Promise<ICliente> {
        const resposta = await this.api.post("/Orcamento/SalvarCliente", {
            identificadorOrcamento,
            cliente
        })
        return resposta.data
    }

    async obterContratoTelaDadosMadeiraItem(identificadorOrcamento: string, identificador: number): Promise<ProdutoMadeiraOrcamentoContract> {
        const resposta = await this.api.get("/Orcamento/ObterContratoTelaDadosMadeiraItem", {
            params: {
                identificadorOrcamento: identificadorOrcamento,
                identificadorItem: identificador
            }
        })
        return resposta.data
    }

    async definirDadosMadeiraItem(identificadorOrcamento: string, identificador: number, contratoMadeira: ProdutoMadeiraOrcamentoContract): Promise<any> {
 
        const resposta = await this.api.post("/Orcamento/DefinirDadosMadeiraItem", {
            identificadorOrcamento: identificadorOrcamento,
            identificadorItem: identificador,
            contratoMadeira: contratoMadeira
        })
         
        return resposta.data
    }

    async ObterInformacoesEnvioEmailClientePorNumero(numero: number): Promise<RespostaModalEnviarEmail> {
        const resposta = await this.api.post("/Orcamento/ObterInformacoesEnvioEmailClientePorNumero", {
            numero
        })
        return resposta.data;
    }
    async ObterInformacoesEnvioWhatsappClientePorNumero(numero: number): Promise<RespostaModalEnviarEmail> {
        const resposta = await this.api.post("/Orcamento/ObterInformacoesEnvioWhatsappClientePorNumero", {
            numero
        })
        return resposta.data;
    }
    async definirAdquirirQuantidadeTotalItemOrcamento(identificadorOrcamento: string, identificador: number, AdquirirQuantidadeTotal: Boolean, SolicitacaoManual: Boolean): Promise<any> {
        const resposta = await this.api.post("/Orcamento/DefinirAdquirirQuantidadeTotalItemOrcamento", {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificador,
            adquirirQuantidadeTotal: AdquirirQuantidadeTotal,
            SolicitacaoManual: SolicitacaoManual
        })
        return resposta.data
    }

    async definirPrecoTintaItem(identificadorOrcamento: string, identificadorItem: number, preco: number): Promise<IOrcamento> {
        return (await this.api.post(`/Orcamento/DefinirPrecoTinta`, {
            definirPrecoTinta: {
                Identificador: identificadorItem,
                IdentificadorOrcamento: identificadorOrcamento,
                Preco: preco
            }
        })).data
    }
    async DefinirIdCorTintometricoSimplificado(identificadorOrcamento: string, identificadorItem: number, idTintaSimplificado: number): Promise<any> { //PA 402355 repasse 311033
        const resposta = await this.api.post("/Orcamento/DefinirIdCorTintometricoSimplificado", {
            identificadorOrcamento: identificadorOrcamento,
            identificador: identificadorItem,
            idTintaSimplificado: idTintaSimplificado
        })
        return resposta.data
    }

    async salvarClienteNaoCadastrado(identificadorOrcamento: string, cliente: any): Promise<any> {
        const resposta = await this.api.post("/Orcamento/SalvarClienteNaoCadastrado", {
            identificadorOrcamento: identificadorOrcamento,
            cliente: cliente
        })
        return resposta.data
    }

    async obterDadosFaturamento(identificadorOrcamento: string): Promise<DadosFaturamento> {
        const resposta = await this.api.post("/Orcamento/ObterDadosFaturamento", {
            identificadorOrcamento: identificadorOrcamento,
        })
        return resposta.data
    }

    async obterDadosResumo(identificadorOrcamento: string): Promise<DadosResumoOrcamento> {
        const resposta = await this.api.post("/Orcamento/ObterDadosResumo", {
            identificadorOrcamento: identificadorOrcamento,

        })
        return resposta.data
    }

    async salvarDadosFaturamentoOutrasSaidas(identificadorOrcamento: string, dadosFaturamento: DadosFaturamento): Promise<DadosFaturamento> {
        const resposta = await this.api.post("/Orcamento/SalvarDadosFaturamentoOutrasSaidas", {
            identificadorOrcamento: identificadorOrcamento,
            dadosFaturamento: dadosFaturamento
        })
        return resposta.data
    }
    async atualizarDadosOrcamento(orcamento: IOrcamento): Promise<AtualizarDadosResumoOrcamento> {
        const resposta = await this.api.post("/Orcamento/AtualizarDadosOrcamento", {
            orcamento: orcamento,

        })
        return resposta.data
    }

    async DefinirPrecoTinta(IdentificadorOrcamento: string, Identificador: number, Preco: string): Promise<ItensTotaisOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirPrecoTinta", { IdentificadorOrcamento, Identificador, Preco })
        return resposta.data
    }

    async dadosDescontos(identificadorOrcamento: string): Promise<DescontoOrcamento> {
        return (await this.api.get(`/Orcamento/DadosDescontos`, {
            params: {
                identificadorOrcamento
            }
        })).data
    }

    async aplicarDescontosAdicionais(identificadorOrcamento: string, descontos: DescontoOrcamento): Promise<DescontoAplicados> {
        return (await this.api.post(`/Orcamento/AplicarDescontosAdicionais`, {
            identificadorOrcamento,
            descontos
        })).data
    }

    async obterMarkup(identificadorOrcamento: string, senha: string, precoMargemAlterados: produtoMarkupAlterado[]): Promise<Markup> {
        /*
        return (await this.api.post(`/Orcamento/ObterMarkup`, {
            identificadorOrcamento,
            senha,
            precoMargemAlterados

        })).data
        */
       
        const dados =await this.api.post(`/Orcamento/ObterMarkup`, {
            identificadorOrcamento,
            senha,
            precoMargemAlterados

        })
        
        return dados.data
    }

    async aplicarPrecoSimuladoMarkup(identificadorOrcamento: string, precoMargemAlterados: produtoMarkupAlterado[]): Promise<IOrcamento> {
        /*
        return (await this.api.post(`/Orcamento/AplicarPrecoSimuladoMarkup`, {
            identificadorOrcamento,
            precoMargemAlterados
        })).data
        */
       
        const dados =await this.api.post(`/Orcamento/AplicarPrecoSimuladoMarkup`, {
            identificadorOrcamento,
            precoMargemAlterados
        })
        
        return dados.data
    }

    async CalendarioCapacidadeCarga(identificadorOrcamento: string, idTipoFrete: number, filial: string, roteiro: string, dataReferencia: DataFormatoEN): Promise<OrcamentoApi.CalendarioCapacidadeCargaItem[]> {
        return (await this.api.get(`/Orcamento/CalendarioCapacidadeCarga`, {
            params: {
                identificadorOrcamento,
                idTipoFrete,
                filial,
                roteiro,
                dataReferencia
            }
        })).data
    }

    async obterDadosAutorizado(identificadorOrcamento: string): Promise<any> {
        const resposta = await this.api.post("/Orcamento/ObterDadosAutorizado", {
            identificadorOrcamento: identificadorOrcamento,
        })
        return resposta.data
    }

    async listarAutorizado(filtros: FiltroListarAutorizados): Promise<ListaAutorizado> {
        const resposta = await this.api.post("/Orcamento/ListarAutorizados", {
            filtros: filtros,
        })
        return resposta.data
    }

    async listarAtividadesPorDescricao(descricao): Promise<Atividade[]> {
        const resposta = await this.api.post("/AtendimentoCliente/ListarAtividadesPorDescricao", {
            descricao,
        })
        return resposta.data
    }

    async definirAutorizado(filtroDefinirAutorizado: FiltroDefinirAutorizado): Promise<DefinirAutorizadoSelecionado> {
        const resposta = await this.api.post("/Orcamento/DefinirAutorizado", {
            definirAutorizado: filtroDefinirAutorizado,
        })
        return resposta.data
    }

    async removerAutorizado(identificadorOrcamento: string): Promise<string> {
        const resposta = await this.api.post("/Orcamento/RemoverAutorizado", {
            identificadorOrcamento: identificadorOrcamento,
        })
        return resposta.data
    }

    async registrarCotacoesPerdidasPorOrcamento(identificadorOrcamento: string, itenSelecionados: number[]): Promise<OrcamentoApi.DadosRegistrarPerdaCotacao> {
        
        const resposta = await this.api.post("/Orcamento/RegistrarCotacoesPerdidasPorOrcamento", {
            identificadorOrcamento,
            itenSelecionados,
        })

        return resposta.data
    }

    async listarMotivos(): Promise<ListaMotivos[]> {
        const resposta = await this.api.get("/Orcamento/ListarMotivos")

        return resposta.data
    }

    async listarConcorrentes(): Promise<ListaConcorrentes[]> {
        const resposta = await this.api.get("/Orcamento/ListarConcorrentes")

        return resposta.data
    }

    async salvarRegistroPerdaCotacao(identificadorOrcamento: string, dados: OrcamentoApi.SalvarRegistroPerdaCotacaoRequisicao): Promise<IOrcamento> {
        
        const resposta = await this.api.post("/Orcamento/SalvarRegistroPerdaCotacao", {
            identificadorOrcamento,
            registroPerdaCotacao: dados
        })

        return resposta.data
    }

    async ConfirmarNovaDataPrevisaoEntregaEncaixeItemOrcamento(identificadorOrcamento: string, identificadoresItens: number[], dataPrevista: DataFormatoEN, filial: string): Promise<IOrcamento> {
        /*
        return (await this.api.post(`/Orcamento/ConfirmarNovaDataPrevisaoEntregaEncaixeItemOrcamento`, {
            listidentificadorOrcamento: [identificadorOrcamento],
            listidentificador: identificadoresItens,
            dataPrevisaoEntrega: dataPrevista,
            FilialCapacidadeCargaEncaixe: filial
        })).data
        */
       const resposta = await this.api.post(`/Orcamento/ConfirmarNovaDataPrevisaoEntregaEncaixeItemOrcamento`, {
            listidentificadorOrcamento: [identificadorOrcamento],
            listidentificador: identificadoresItens,
            dataPrevisaoEntrega: dataPrevista,
            FilialCapacidadeCargaEncaixe: filial
        })
        
        return resposta.data
    }


    async definirEntregaPosteriorItemOrcamento(identificadorOrcamento: string, identificador: number, entregaPosterior: boolean): Promise<IOrcamento> {
        const resposta = await this.api.post(`/Orcamento/DefinirEntregaPosteriorItemOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            identificador,
            entregaPosterior
        })
        return resposta?.data
    }


    async DumpOrcamento(identificadorOrcamento: string, nivel: number, nomeDump: string = null) {
        return (await this.api.post(`/Orcamento/DumpOrcamento`, {
            identificadorOrcamento: identificadorOrcamento,
            nivel: nivel,
            nomeDump: nomeDump
        })).data


    }

    async VerificarPendenciaVendaFrete(): Promise<boolean> {
        return ((await this.api.get(`/Orcamento/VerificarPendenciaVendaFrete`)).data) == "true"
    }

    async VerificarPendenciaFormaDePagamento(): Promise<boolean> {
        return ((await this.api.get(`/Orcamento/VerificarPendenciaFormaDePagamento`)).data) == "true"
    }

    async GerarPdfTemplatePadrao(numero: number,
        siglaFuncionalidade: string,
        siglaAcao: string): Promise<any> {
        return this.api.get(`${globalMU.restUrl()}/api/venda/orcamento/gerarpdftemplatepadrao?token=${encodeURIComponent(globalMU.token())}`, {
            headers: { Accept: "*/*" },
            responseType: 'arraybuffer',
            params: {
                numero: numero,
                siglaFuncionalidade: siglaFuncionalidade,
                siglaAcao: siglaAcao
            }
        });
    }

    async ObterListaPedidoDespesa(identificadorOrcamento: string): Promise<DespesaOrcamento[]> { //440122
            const resposta = await this.api.post(`/Orcamento/ObterListaPedidoDespesa`, {
                    identificadorOrcamento
                }
            )  
            return resposta.data
        }


    async AtualizarPedidoDespesa(identificadorOrcamento: string, oidDespesa: number, oidFornecedor: number, valor: number): Promise<DespesaOrcamento[]> { //440122
            const resposta = await this.api.post(`/Orcamento/AtualizarPedidoDespesa`, {
                    identificadorOrcamento,
                    oidDespesa,
                    oidFornecedor,
                    valor
                }
            )  
            return;
        }

    async DefinirControleExclusividade(numeroPedido: number, codigoSituacaoManutencao: string): Promise<boolean> {
        return (await this.api.post(`${globalMU.restUrl()}/api/venda/orcamento/definirControleExclusividade`, null, {
            params: {
                numeroPedido,
                codigoSituacaoManutencao,
                token: globalMU.token()
            }
        })).data;
    }

    async RemoverControleExclusividade(numeroPedido: number, removerOidFilial: boolean): Promise<boolean> {
        return (await this.api.post(`${globalMU.restUrl()}/api/venda/orcamento/removerControleExclusividade`, null, {
            params: {
                numeroPedido: numeroPedido,
                ehParaCheckoutMovel: false,
                removerOidFilial: removerOidFilial, // 460020
                token: globalMU.token()
            }
        })).data;
    }

    async definirValorServicosAgregados(identificadorOrcamento: string, valorServicosAgregados: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/DefinirValorServicosAgregados", {
            identificadorOrcamento,
            valorServicosAgregados
        })

        return resposta.data
    }

    async obterListaServicosAgregados(CodigoProduto: string, PrecoProduto: number, tamanhoPaginas: number, numeroPaginas: number): Promise<ServicoAgregado> {
        const resposta = await this.api.post(`/Orcamento/ObterListaServicosAgregados`,{

                CodigoProduto,
                PrecoProduto,
                tamanhoPaginas,
                numeroPaginas
            
        })

        return resposta.data
    }

    async adicionarServicosAgregados(identificadorOrcamento: string, CodigosServicosAgregados: InputAdicionarCodigoServicoAgregado[]): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/AdicionarServicosAgregados", {
            identificadorOrcamento,
            CodigosServicosAgregados
        })

        return resposta.data
    }

    async removerServicosAgregados(identificadorOrcamento: string, identificadorItem: number): Promise<IOrcamento> {
        const resposta = await this.api.post("/Orcamento/RemoverServicosAgregados", {
            identificadorOrcamento,
            identificadorItem
        })

        return resposta.data
    }

    async definirResponsavelExecutor(identificadorOrcamento: string, CodigosServicosAgregados: InputAdicionarCodigoServicoAgregado[]): Promise<boolean> {
        const resposta = await this.api.post("/Orcamento/DefinirResponsavelExecutor", {
            identificadorOrcamento,
            CodigosServicosAgregados
        })

        return resposta.data
    }

    async limparResponsavelExecutor(identificadorOrcamento: string): Promise<boolean> {
        const resposta = await this.api.post("/Orcamento/LimparResponsavelExecutor", {
            identificadorOrcamento
        })

        return resposta.data
    }

    async definirSnapshotId(snapshotId: string): Promise<boolean> {
        const resposta = await this.api.post("/Orcamento/DefinirSnapshotId", {
            snapshotId
        })

        return resposta.data
    }

}

export namespace OrcamentoApi {
    export type BuscarTiposFretesDisponiveisItem = {
        IdTipoFrete?: number
        EhFreteEspecial?: boolean
        Descricao?: string
    }

    export type CalendarioCapacidadeCargaItem = {
        backgroundcolor: "green" | "blue" | "red"
        data: DataFormatoPT
    }
    export type SalvarRegistroPerdaCotacaoRequisicao = {
        ItenSelecionados: number[]
        ManterItem: boolean
        Observacao: string
        CodigoConcorrente: number
        PrecoConcorrente: number
        CodigoMotivo: number
        Quantidade: number
        PerdaCotacaoTodosItens: boolean // 470698
    }

    export type SimularDescontoResposta = {
        CodigoObjetoItem?: number
        DescontoPendente?: boolean
        BonificacaoPendente?: boolean
        IdentificadorOrcamento?: any
        PercentualDesconto?: number
        PercentualBonificacao?: number
        Preco?: number
        PercentualDescontoGeralOrcamento?: any
        PercentualDescontoTotal?: number
        PercentualComissao?: any
        Comissao?: any
        PendenciaDescontoSobreOferta?: boolean
        PercentualMaximoDesconto?: number // 448892
        PreservaDesconto?: boolean
        UserMessage?: any
        Transforming?: boolean

    }

    export interface SimularDescontoRequisicao {
        identificadorOrcamento?: string
        codigoObjetoItem?: number
        preco?: any
        percentualDesconto?: number
        percentualBonificacao?: number
        percentualDescontoGeralOrcamento?: number
        preservaDesconto?: boolean
    }

    export type ObterMotivosDescontoResposta = {
        Codigo?: number
        Motivo?: string
    }[]

    export type ObterEncomendaItemOrcamentoResposta = {
        AdquirirQuantidadeTotal?: boolean;
        EncomendaAutomatica?: boolean;
        PrazoEntregaFornecedor: number;
        Produto: string;
        Quantidade: number;
        QuantidadeDisponivel: number;
        QuantidadeDisponivelPedido: number;
        QuantidadeEstoque: number;
        QuantidadePedidosCompra: number;
        QuantidadeReservada: number;
        QuantidadeReservadaPedido: number;
        TipoVendaSobEncomenda: number;
    }

    export type DadosRegistrarPerdaCotacao = {
        Motivos: ListaMotivos[]
        Concorrentes: ListaConcorrentes[]
        RegistrarCotacoesPerdidasPorOrcamento: {
            NomeCliente?: string
            CPFCNPJ?: string
            CodigoProduto?: string,
            DescricaoProduto?: string,
            Quantidade?: number
            PrecoVenda?: number
            CodigoConcorrente?: number
            PrecoConcorrente?: number
            CodigoMotivo?: string,
            Observacao?: string,
            PerdaCotacao?: {
                Codigo: number,
                CodigoFilial: number,
                NumeroPedido: number,
                CodigoCliente: number,
                DataMovimentacao: string,
                Quantidade: number,
                CodigoMotivo: string,
                DescricaoMotivo: string,
                NomeConcorrente: string,
                CodigoConcorrente: number,
                PrecoConcorrente: number,
                PrecoVenda: number,
                Moeda: number,
                Observacao: string,
                CodigoVendedor: string,
                ICMS: number,
                CodigoProduto?: string,
                DescricaoProduto?: string,
                CodigoProdutoExibicao: string,
                DescricaoProdutoExibicao: string,
                UserMessage?: string,
                Transforming: boolean
            }[],
            UserMessage?: string,
            Transforming?: boolean
        }
    }
}

export type GerarParcelasPlanoPagamentoRequisicao = {
    CodigoPlanoPagamento?: number;
    CodigoParcela?: number;
    CodigoCarencia?: number;
    ComEntrada?: boolean
    ValorEntrada?: number
    CodigoDocumentoEntrada?: number
}

export type ListarTiposDocumentoEntradaRespostaItem = {
    Cid?: number;
    Codigo?: number;
    Descricao?: string;
    Tipo?: number;
    TipoParcela?: number;
    QuantidadeMinimaParcelaVista?: number;
    QuantidadeMaximaParcelaVista?: number;
    QuantidadeMinimaParcelaPrazo?: number;
    QuantidadeMaximaParcelaPrazo?: number;
    TipoDocumentoBloqueadoParaCliente?: boolean;
    PixAPrazoHabilitadoParaCobranca?: boolean // 414608
    NomeInterno?: any;
    OidTransacaoCieloLio?: number;
}

export type RemoverPlanoPagamentoResposta = {
    CodigoCarenciaPlanoPagamento?: number;
    CodigoDocumentoEntrada?: number;
    CodigoDocumentoPlanoPagamento?: number;
    CodigoParcelaPlanoPagamento?: number;
    CodigoPlanoPagamento?: number;
    DescricaoPlanoPagamento?: string;
    DiasCarenciaPlanoPagamento?: number;
    NomeDocumentoEntrada?: string;
    NomeDocumentoPlanoPagamento?: string;
    Parcelas?: any;
    PlanoPagamentoComEntrada?: boolean;
    QuantidadeParcelasPlanoPagamento?: number;
    ValorEntrada?: number;
}

export type SimularFinanciamentoRequisicaoResposta = {
    CodigoPlanoPagamento?: number,
    CodigoParcela?: number,
    CodigoCarencia?: number,
    ValorEntrada?: number,
    ValorFinanciado?: number,
    ValorParcela?: number,
}

export type ListarCarenciasParcelaPlanoPagamentoPorCodigo = {
    Codigo?: number
    Dias?: number
}

export type ListarParcelasPlanoPagamentoPorCodigoRespostaItem = {
    Codigo?: number,
    Quantidade?: number
}

export type AtualizarParcelaContratoRequisicao = {
    NumeroDocumento?: string;
    NumeroBanco?: string;
    NumeroAgencia?: string;
    NumeroConta?: string;
    Vencimento?: string;
    Valor?: number;
}

export type ListarCarenciasParcelaPlanoPagamentoRespostaItem = {
    Codigo?: number
    Dias?: number
}

export type ListarParcelasPlanoPagamentoRespostaItem = {
    Codigo?: number,
    Quantidade?: number
}

export type ObterDadosFormaPagamentoResposta = {
    CodigoFormaPagamento?: number
    CodigoTipoDocumento?: number
    FormasPagamento?: {
        AreaVenda?: number
        Avista?: any
        Codigo?: number
        Entrada?: number
        Nome?: string
        QuantidadeParcelasPrazo?: number
        TipoDocumentoBloqueadoParaCliente?: boolean
        TaxaPadrao?: number
        UserMessage?: any
        Transforming?: boolean
    }[]
    Parcelas?: {
        Codigo?: number
        CodigoCMC7?: string
        ContaPortadora?: number
        DescricaoTipo?: "A Prazo" | "À Vista"
        Documento?: string
        RecebimentoNaEntrega?: boolean
        IdTipoDocumento?: number
        Index: number
        NumeroAgencia?: string
        NumeroBanco?: string
        NumeroConta?: string
        NumeroDocumento?: string
        Tipo?: 2
        Valor?: number
        Vencimento?: string
        QuantidadeParcelasCartao?: number
        ValorParcelasCartao?: number
        TipoDocumentoPadrao?: boolean
        DocumentoElegivelPIXaPrazo?: boolean // 419846
        Descricao?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
    RecalcularParcelas?: boolean
    RecalcularPrecos?: boolean // 419846
    RecalcularVencimentoNoFaturamento?: boolean
    TiposDocumento?: {
        Cid?: number
        Codigo?: number
        Descricao?: string
        Tipo?: number
        TipoParcela?: number
        QuantidadeMinimaParcelaVista?: number
        QuantidadeMaximaParcelaVista?: number
        QuantidadeMinimaParcelaPrazo?: number
        QuantidadeMaximaParcelaPrazo?: number;
        TipoDocumentoBloqueadoParaCliente?: boolean
        PixAPrazoHabilitadoParaCobranca?: boolean // 414608
        NomeInterno?: any
        OidTransacaoCieloLio?: number
        UserMessage?: any
        Transforming?: boolean
    }[]
    TipoDocumentoBloqueadoParaCliente?: boolean
    PendenciaPrazoMedioEntrega?: boolean
    ElegivelParaEmailCobrancaPixPrazo?: boolean // 414608
    UserMessage?: any
    Transforming?: boolean
}

export type AtualizarParcelaResposta = {
    ParcelasFormaPagamento: {
        Codigo?: number
        CodigoCMC7?: string
        ContaPortadora?: number
        DescricaoTipo?: "A Prazo"
        Documento?: string
        RecebimentoNaEntrega?: boolean
        IdTipoDocumento?: number
        Index?: number
        NumeroAgencia?: string
        NumeroBanco?: string
        NumeroConta?: string
        NumeroDocumento?: string
        Tipo?: 2
        Valor?: number
        Vencimento?: string
        QuantidadeParcelasCartao?: number
        ValorParcelasCartao?: number
        TipoDocumentoPadrao?: boolean
        DocumentoElegivelPIXaPrazo?: boolean // 419846
        Descricao?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
}

export type IgualarParcelasPrazoResposta = {
    ParcelasFormaPagamento: {
        Codigo?: number
        CodigoCMC7?: string
        ContaPortadora?: number
        DescricaoTipo?: "A Prazo"
        Documento?: string
        RecebimentoNaEntrega?: boolean
        IdTipoDocumento?: number
        Index?: number
        NumeroAgencia?: string
        NumeroBanco?: string
        NumeroConta?: string
        NumeroDocumento?: string
        Tipo?: 2
        Valor?: number
        Vencimento?: string
        QuantidadeParcelasCartao?: number
        ValorParcelasCartao?: number
        TipoDocumentoPadrao?: boolean
        DocumentoElegivelPIXaPrazo?: boolean // 419846s
        Descricao?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
}

export type ObterTiposDocumentoResposta = {
    Cid: number
    Codigo: number
    Descricao: string
    Tipo: number
    TipoParcela: number
    QuantidadeMinimaParcelaVista: number
    QuantidadeMaximaParcelaVista: number
    QuantidadeMinimaParcelaPrazo: number
    QuantidadeMaximaParcelaPrazo: number;
    TipoDocumentoBloqueadoParaCliente: boolean
    NomeInterno: any
    OidTransacaoCieloLio: number
    UserMessage: any
    Transforming: boolean
}[]

export type ObterDadosParaInsercaoEdicaoParcelaResposta = {
    TiposDocumento?: {
        Cid?: number
        Codigo?: number
        Descricao?: string
        Tipo?: number
        TipoParcela?: number
        QuantidadeMinimaParcelaVista?: number
        QuantidadeMaximaParcelaVista?: number
        QuantidadeMinimaParcelaPrazo?: number
        QuantidadeMaximaParcelaPrazo?: number;
        TipoDocumentoBloqueadoParaCliente?: boolean
        PixAPrazoHabilitadoParaCobranca?: boolean // 414608
        NomeInterno?: string
        OidTransacaoCieloLio?: number
        UserMessage?: any
        Transforming?: boolean
    }[]
    TiposParcelas?: {
        Codigo?: number
        Descricao?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
    ContasPortadoras?: {
        Codigo?: number
        Nome?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
    ValorRestanteParcela?: number
}

export type ListarTipoEntrega = {
    Codigo: string;
    Descricao: string;
};

export type SimularDescontoItem = {
    CodigoObjetoItem?: number,
    DescontoPendente?: boolean,
    BonificacaoPendente?: boolean,
    IdentificadorOrcamento?: string,
    PercentualDesconto?: number,
    PercentualBonificacao?: number,
    Preco?: number,
    PercentualDescontoGeralOrcamento?: number,
    PercentualDescontoTotal?: number,
    PercentualComissao?: number,
    Comissao?: number,
    PendenciaDescontoSobreOferta?: boolean,
    UserMessage?: string,
    Transforming?: boolean
}
export type ObterDadosPlanoPagamentoResposta_Parcela = {
    Codigo?: number;
    CodigoCMC7?: string;
    ContaPortadora?: number | null;
    DescricaoTipo?: string;
    Documento?: string;
    RecebimentoNaEntrega?: boolean | null;
    IdTipoDocumento?: number;
    Index?: number;
    NumeroAgencia?: string;
    NumeroBanco?: string;
    NumeroConta?: string;
    NumeroDocumento?: string;
    Tipo?: number
    Valor?: number;
    Vencimento?: string
    QuantidadeParcelasCartao?: number;
    ValorParcelasCartao?: number;
    TipoDocumentoPadrao?: boolean;
    Descricao?: string;
}

export type ObterDadosPlanoPagamentoResposta = {
    Carencias?: {
        Codigo?: number,
        Dias?: number
    }[],
    IdentificadorOrcamento?: string
    ParcelasPlanoPagamento?: {
        Codigo?: number,
        Quantidade?: number
    }[],
    PlanosPagamento?: {
        Codigo?: string
        Nome?: string
        UserMessage?: any
        Transforming?: boolean
    }[]
    TiposDocumentoEntrada?: {
        Cid?: number;
        Codigo?: number;
        Descricao?: string;
        Tipo?: number;
        TipoParcela?: number;
        QuantidadeMinimaParcelaVista?: number;
        QuantidadeMaximaParcelaVista?: number;
        QuantidadeMinimaParcelaPrazo?: number;
        QuantidadeMaximaParcelaPrazo?: number;
        TipoDocumentoBloqueadoParaCliente?: boolean;
        PixAPrazoHabilitadoParaCobranca?: boolean // 414608
        NomeInterno?: string;
        OidTransacaoCieloLio?: number;
    }[],
    CodigoDAV?: string
    SomenteLeitura?: boolean
    CodigoCarencia?: number
    CodigoDocumentoEntrada?: number
    CodigoDocumentoPlanoPagamento?: number
    CodigoParcela?: number
    CodigoPlanoPagamento?: number
    ComEntrada?: boolean
    Contrato?: {
        NomeFinanceira?: string,
        ParcelasFinanciamento?: ObterDadosPlanoPagamentoResposta_Parcela[],
        ValorParcelas?: number,
        ValorTAC?: number,
        ValorTotal?: number
        Valor?: number
        Descricao?: string
    },
    DescricaoPlanoPagamento?: string
    DiasCarenciaPlanoPagamento?: number
    Entrada?: ObterDadosPlanoPagamentoResposta_Parcela
    NomeDocumentoEntrada?: string
    NomeDocumentoPlanoPagamento?: string
    QuantidadeParcelasPlanoPagamento?: number
    TipoDocumentoBloqueadoParaCliente?: boolean
    UtilizaPlanoPagamento?: boolean
    ValorEntrada?: number
    UserMessage?: any
    Transforming?: boolean
}

export type DefinirPlanoPagamentoResposta = {
    CodigoCarencia?: number;
    CodigoDocumentoEntrada?: number;
    CodigoDocumentoPlanoPagamento?: number;
    CodigoParcela?: number;
    CodigoPlanoPagamento?: number;
    ComEntrada?: boolean;
    Contrato?: {
        NomeFinanceira?: string;
        ParcelasFinanciamento?: {
            Codigo?: number;
            CodigoCMC7?: any;
            ContaPortadora?: any;
            DescricaoTipo?: string;
            Documento?: any;
            RecebimentoNaEntrega?: boolean;
            IdTipoDocumento?: number;
            Index?: number;
            NumeroAgencia?: string;
            NumeroBanco?: string;
            NumeroConta?: string;
            NumeroDocumento?: string;
            Tipo?: number;
            Valor?: number;
            Vencimento?: Date;
            QuantidadeParcelasCartao?: number;
            ValorParcelasCartao?: number;
            TipoDocumentoPadrao?: boolean;
            Descricao?: string;
            UserMessage?: any;
            Transforming: boolean;
        }[]
        ValorParcelas?: number;
        ValorTAC?: number;
        ValorTotal?: number;
        Codigo?: number;
        CodigoCMC7?: string;
        ContaPortadora?: number;
        DescricaoTipo?: string;
        Documento?: string;
        RecebimentoNaEntrega?: boolean;
        IdTipoDocumento?: number;
        Index?: number;
        NumeroAgencia?: string;
        NumeroBanco?: string;
        NumeroConta?: string;
        NumeroDocumento?: string;
        Tipo?: number;
        Valor?: number;
        Vencimento?: Date;
        QuantidadeParcelasCartao?: number;
        ValorParcelasCartao?: number;
        TipoDocumentoPadrao?: boolean;
        DocumentoElegivelPIXaPrazo?: boolean // 414608
        Descricao?: string;
    }
    DescricaoPlanoPagamento?: string;
    DiasCarenciaPlanoPagamento?: number;
    Entrada?: any;
    NomeDocumentoEntrada?: string;
    NomeDocumentoPlanoPagamento?: string;
    QuantidadeParcelasPlanoPagamento?: number;
    TipoDocumentoBloqueadoParaCliente?: boolean;
    UtilizaPlanoPagamento?: boolean;
    ValorEntrada?: number;
}


export type DadosModalidadeEntrega = {
    UtilizaModalidadeEntregaOrcamento: boolean,
    ModalidadesEntrega: ModalidadesEntrega[],
    PontosRetirada: PontosRetirada[]
}

export type ModalidadesEntrega = {
    Codigo: number,
    Item: any
    CodigoCategoria: string,
    Nome: string,
    NomeInterno: string,
    Descendencias: any,
    Classificacao: any,
    OidSuper: number,
    Cid: number,
    Observacao: string
}


export type PontosRetirada = {
    Id: number,
    Cnpj: string
    Tipo: number
    OidFilial: number
    OidPessoa: number
    Nome: string
    Logradouro: string
    Numero: string
    Complemento: string
    Bairro: string
    Cep: string
    OidCidade: number
    Inativo: number
}


export type SalvarRegistroPerdaCotacao = {
    DescontoAcumulado: number
    ItensOrcamento: IItemOrcamento[]
    PercentualDesconto: number
    PercentualDescontoAcumulado: number
    PercentualSeguroEntrega: number
    SubTotal: number
    ValorAcrescimoFinanceiro: number
    ValorDesconto: number
    ValorDespesasInclusas: number
    ValorFrete: number
    ValorIPI: number
    ValorSeguroEntrega: number
    ValorSubstituicao: number
    ValorTotal: number
    ValorTotalPendente: number
    ValorTotalSolicitado: number
    ValorDescontoIcms: number
    ValorTotalMercadorias: number
    ValorTotalMercadoriasNacionais: number
    ValorTotalMercadoriasImportadas: number
    PercentualDescontoSobreMercadoriasNacionais: number
    PercentualDescontoSobreMercadoriasImportadas: number
    ValorDescontoSobreMercadoriasNacionais: number
    ValorDescontoSobreMercadoriasImportadas: number
    TipoTratamentoDesconto: number
    ValorTotalSTSobreMercadoriasImportadas: number
    ValorTotalSTSobreMercadoriasNacionais: number
    ValorTotalIPISobreMercadoriasImportadas: number
    ValorTotalIPISobreMercadoriasNacionais: number
    ValorDescontoAcumuladoSobreMercadoriasNacionais: number
    ValorDescontoAcumuladoSobreMercadoriasImportadas: number
    PercentualDescontoAcumuladoSobreMercadoriasNacionais: number
    PercentualDescontoAcumuladoSobreMercadoriasImportadas: number

    SaldoCashbackCliente?: number; // 438892
    ValidadeCashbackCliente?: string;
    ValorCashbackUtilizado?: number;
    AplicaDescontoCashback?: boolean;
    
    PerdaCotacao: any
    CodigoMotivoDesconto: number
    UltimaAtualizacao: string
    AptoParaGestaoDeFretes: boolean
    NumeroDiasMaximoParaPrevisaoEntrega: number
    ValorFreteModificadoManualmente: boolean
    ManterReserva?: boolean  // 455920/74856
    OidFornecedorPorRepresentacao?: number // 456252
    UserMessage: any
    Transforming: boolean
}

export type ProdutoMadeiraOrcamentoContract = {
    CodigoProduto?: string;
    Unidade?: string;
    Altura?: number;
    Comprimento?: number;
    Espessura?: number;
    Largura?: number;
    QuantidadeSolicitada?: number;
    TipoPrecoVenda?: number;
    TotalCalculadoMetro?: number;
    PrecoVenda1?: number;
    PrecoVenda2?: number;
    PrecoVenda3?: number;
    PercentualPrecoVenda2?: number;
    PercentualPrecoVenda3?: number;
    TotalCalculadoPreco?: number;
}
